import { useState, useEffect } from 'react'

interface WindowDimensions {
  width: number
  height: number
}

/**
 * Hook for tracking browser window dimensions
 * Equivalent of Dimensions.get("screen") from React Native
 */
export const useWindowDimensions = (): WindowDimensions => {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>({
    width: typeof window !== 'undefined' ? window.innerWidth : 375,
    height: typeof window !== 'undefined' ? window.innerHeight : 812,
  })

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }

    // Add window resize listener
    window.addEventListener('resize', handleResize)

    // Set initial dimensions
    handleResize()

    // Clean up listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return windowDimensions
}
